export var Token;
(function (Token) {
    Token["BTC"] = "BTC";
    Token["TBTC"] = "tBTC";
})(Token || (Token = {}));
